import React from 'react';
import css from './OrderPanel.module.css';
import { SecondaryButton } from '../Button/Button';
import { FormattedMessage } from 'react-intl';
const MakeOfferButton = ({
  shouldHideMakeAnOfferButton,
  isOwnListing,
  onClick,
  className = css.makeOfferButton,
  ...buttonProps // For additional props like type, disabled, etc.
}) => {
  if (shouldHideMakeAnOfferButton || isOwnListing) {
    return null;
  }

  return (
    <SecondaryButton className={className} type="button" onClick={onClick} {...buttonProps}>
      <FormattedMessage id="ProductOrderForm.makeAnOffer" />
    </SecondaryButton>
  );
};

export default MakeOfferButton;
